import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../img/about/powerzone_logo.png';

function Header() {
  const [isMobileNavActive, setMobileNavActive] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSection, setActiveSection] = useState('/');
  const [activeLink, setActiveLink] = useState('/');

  const location = useLocation();

  const handleMobileToggle = () => {
    setMobileNavActive(!isMobileNavActive);
  };

  const closeMobileMenu = () => {
    setMobileNavActive(false);
  };

  const handleScroll = () => {
    // const sections  = ['about', 'services', 'solutions', 'team', 'why-choose-us', 'contact'];
    const sections  = ['about', 'services', 'solutions', 'why-choose-us', 'contact'];
    for (let id of sections) {
      const section = document.getElementById(id);
      if (section) {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 120 && rect.bottom >= 120) {
          setActiveSection(id);
          break;
        }
      }
    }
  };

  const handleDropdownToggle = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const handleNavClick = (link) => {
    setActiveLink(link);
    closeMobileMenu();
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header d-flex align-items-center fixed-top ${isMobileNavActive ? 'mobile-nav-active' : ''}`}>
      <div className="container position-relative d-flex align-items-center justify-content-between">

        <Link to="/" className="logo d-flex align-items-center me-auto me-xl-0">
          <img src={logo} alt="Powerzone Logo" />
        </Link>

        <nav id="navmenu" className="navmenu">
          <ul>
            {/* <li>
              <Link
                to="/"
                onClick={() => handleNavClick('/')}
                className={location.pathname === '/' ? 'active' : ''}
              >
                Home
              </Link>
            </li> */}

            {/* <li><a href="#hero">Home</a></li> */}
            <li>
              <a href="#about" className={activeSection === 'about' ? 'active' : ''} onClick={closeMobileMenu}>
                About
              </a>
            </li>
            <li>
              <a
                href="#services"
                className={activeSection === 'services' ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#solutions"
                className={activeSection === 'solutions' ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                Solutions
              </a>
            </li>
            {/* <li>
              <a
                href="#team"
                className={activeSection === 'team' ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                Team
              </a>
            </li> */}

            {/* <li>
              <Link
                to="/solutions"
                onClick={() => handleNavClick('/solutions')}
                className={activeLink === '/solutions' ? 'active' : ''}
              >
                Solutions
              </Link>
            </li> */}
            {/* <li className={`dropdown ${(activeDropdown === 1 || location.pathname.startsWith('/ip-chart') || location.pathname.startsWith('/panel-formation')) ? 'active' : ''}`}>
              <Link
                to="/technical"
                onClick={(e) => {
                  e.preventDefault();
                  handleDropdownToggle(1);
                }}
              >
                <span>Technical Tables</span>
                <i className={`bi ${(activeDropdown === 1 || location.pathname.startsWith('/ip-chart') || location.pathname.startsWith('/panel-formation')) ? 'bi-chevron-up' : 'bi-chevron-down'} toggle-dropdown`}></i>
              </Link>
              <ul className={(activeDropdown === 1 || location.pathname.startsWith('/ip-chart') || location.pathname.startsWith('/panel-formation')) ? 'dropdown-active' : ''}>
                <li><Link to="/ip-chart">IP Chart</Link></li>
                <li><Link to="/panel-formation">Panel Information</Link></li>
              </ul>
            </li> */}


            {/* Dropdown */}
            <li className={`dropdown ${activeDropdown === 2 ? 'active' : ''}`}>
              <Link
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDropdownToggle(2);
                }}
              >
                <span>Products</span>{' '}
                <i className={`bi ${activeDropdown === 2 ? 'bi-chevron-up' : 'bi-chevron-down'} toggle-dropdown`}></i>
              </Link>
              <ul className={activeDropdown === 2 ? 'dropdown-active' : ''}>
                <li className="dropdown">
                  <Link href="#" onClick={(e) => e.preventDefault()}>
                    <span>Power Distribution</span> <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </Link>
                  <ul className={activeDropdown === 2 ? 'dropdown-active' : ''}>
                    <li><Link to="/ht-switcher">HT Switchgear</Link></li>
                    <li><Link to="/load-break-switch">Load Break Switch</Link></li>
                    <li><Link to="/lt-switchgear">LT Switchgear</Link></li>
                    {/* <li><Link to="/main-distribution-box">Power Factor Improve Panel</Link></li> */}
                   
                    <li><Link to="/ats-panel">ATS Panel</Link></li>
                    <li><Link to="/power-distribution">POWER & DISTRIBUTION</Link></li>
                    <li><Link to="/ring-main-unit">Ring Main Unit</Link></li>
                    <li><Link to="/ht-lt-avr">HT & LT AVR</Link></li>
                    {/* <li><Link to="/main-distribution-box">Main Distribution Box</Link></li> */}
                    <li><Link to="/apfc">Apfc Panel</Link></li>
                    {/* <li><Link to="/auto-chnage-over-panel">Auto Chnage Over Panel</Link></li> */}
                    <li><Link to="/mcc-panel">Motor Control Panel</Link></li>
                    {/* <li><Link to="/vfd-soft-starter-panel">VFD & Soft Starter Panel</Link></li> */}
                    <li><Link to="/synchronizing-panel">Synchronization Panel</Link></li>
                  </ul>
                </li>
                <li><Link to="/busbar-truncking">Busbar Trunking System</Link></li>
                {/* <li className="dropdown">
                  <Link href="#" onClick={(e) => e.preventDefault()}>
                    <span>Solar Product System</span> <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </Link>
                  <ul className={activeDropdown === 2 ? 'dropdown-active' : ''}>
                    <li><Link to="/ac-distribution-box">AC Distribution Box</Link></li>
                    <li><Link to="/dc-distribution-box">DC Distribution Box</Link></li>
                    <li><Link to="/ac-combiner-box">AC Combiner Box</Link></li>
                  </ul>
                </li> */}
                <li><Link to="/solar-product-system">Solar Product System</Link></li>
                <li><Link to="/substation-overview">Substation Overview</Link></li>
                <li><Link to="/lighting-protection">Lighting Protection System</Link></li>
                <li><Link to="/battery-bank">Battery Bank</Link></li>
              </ul>
            </li>

            {/* <li>
              <Link
                to="/about"
                onClick={() => handleNavClick('/about')}
                className={location.pathname === '/about' ? 'active' : ''}
              >
                About Us
              </Link>
            </li> */}

            {/* <li>
              <Link
                to="/contact"
                onClick={() => handleNavClick('/contact')}
                className={location.pathname === '/contact' ? 'active' : ''}
              >
                Contact
              </Link>
            </li> */}

            <li>
              <a
                href="#why-choose-us"
                className={activeSection === 'why-choose-us' ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                Why Choose Us
              </a>
            </li>

            <li>
              <a
                href="#contact"
                className={activeSection === 'contact' ? 'active' : ''}
                onClick={closeMobileMenu}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>

        {/* Mobile Nav Toggle Button */}
        <i
          className={`mobile-nav-toggle d-xl-none bi ${isMobileNavActive ? 'bi-x' : 'bi-list'}`}
          onClick={handleMobileToggle}
          style={{ cursor: 'pointer', marginLeft: 'auto' }}
        ></i>
      </div>
    </header>
  );
}

export default Header;
